<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Reporte de Estado de Cuenta</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="consultar" class="btn-info btn--bigger">
                        <i class="fa fa-search"></i><span>Consultar</span>
                    </button>
                    <button @click="exportar" class="btn-success btn--bigger">
                        <i class="fa fa-file-excel-o"></i><span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Información de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2" :class="{
                        'select2--disabled': bodegas.length == 1
                        }">
                            <div class="select2-field">
                                <v-select @input="inputBodega" v-model="selectedBodega" :options="bodegas" label="descripcion" placeholder="Seleccione..."></v-select>
                                <label for="bodegas">Sucursal</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                placeholder="Seleccione..."
                                id="supervisor_id"
                                v-model="selectedRecaudadores"
                                :options="recaudadores"
                                multiple
                                @input="inputRecaudadores"
                                @search="searchRecaudadores"
                                label="nombre"
                                ></v-select>
                                <label for="supervisor_id">Persona</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo" v-model="form.tipo" id="tipo">
                                    <option value="T">Todos</option>
                                    <option value="P">Pagados</option>
                                    <option value="N">Pendientes</option>
                                </select>
                                <label for="tipo">Tipo</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-inline">
                            <label for="descuentos">
                                <input @change="consultar" v-model="form.tipo_movimiento" type="radio" name="tipo_movimiento" id="descuentos" value="G"><span>Descuentos</span>
                            </label>
                            <label for="ingresos">
                                <input @change="consultar" v-model="form.tipo_movimiento" type="radio" name="tipo_movimiento" id="ingresos" value="I"><span>Ingresos</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Movimientos de Nómina</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table
                            :buscarButton="false"
                            :filterStatus="false"
                            :deleteButton="false"
                            :createButton="false"
                            :editButton="false"
                            :params="form"
                            ref="movimientos"
                            :path="path"
                            :columns="[
                                {
                                display: 'Tipo de movimiento',
                                value: 'tipo_movimiento.descripcion',
                                },
                                {
                                display: 'Sucursal',
                                value: 'bodega.descripcion',
                                },
                                {
                                display: 'Fecha',
                                value: 'fecha',
                                },
                                {
                                display: 'Persona',
                                value: 'persona.nombre',
                                },
                                {
                                display: 'Detalle',
                                value: 'detalle',
                                },
                                {
                                display: 'Debe',
                                value: 'valor',
                                numeric: true,
                                },
                                {
                                display: 'Descuento',
                                value: 'descuento',
                                numeric: true,
                                },
                                {
                                display: 'Saldo',
                                value: 'saldo',
                                numeric: true,
                                },
                                {
                                display: 'Creación',
                                value: 'created_at',
                                },
                            ]"
                            ></k-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Movimientos de caja</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table
                            :buscarButton="false"
                            :filterStatus="false"
                            :deleteButton="false"
                            :createButton="false"
                            :editButton="false"
                            :params="form"
                            ref="movimientosCaja"
                            :path="pathCaja"
                            :columns="[
                                {
                                display: 'Tipo de movimiento',
                                value: 'tipo_gasto.descripcion',
                                },
                                {
                                display: 'Sucursal',
                                value: 'bodega.descripcion',
                                },
                                {
                                display: 'Fecha',
                                value: 'fecha',
                                },
                                {
                                display: 'Persona',
                                value: 'persona.nombre',
                                },
                                {
                                display: 'Detalle',
                                value: 'detalle',
                                },
                                {
                                display: 'Debe',
                                value: 'valor',
                                numeric: true,
                                },
                                {
                                display: 'Creación',
                                value: 'created_at',
                                },
                            ]"
                            ></k-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                tipo: 'T',
                recaudadores_id:  [],
                bodega_id: '',
                tipo_consulta: 'N',
                tipo_movimiento: 'G'
            },
            selectedRecaudadores: [],
            selectedBodega: null,
            path: url + '/reporte-estado-cuenta',
            recaudadores: [],
            pathCaja: url + '/reporte-estado-cuenta-caja'
        };
    },
    props: {
        bodegas: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    methods: {
        exportar: function () {
            this.form.tipo_consulta = 'E';
            this.$refs.movimientos.exportar();
        },
        consultar: function () {
            this.form.tipo_consulta = 'N';
            this.$refs.movimientos.loadRows();
            this.$refs.movimientosCaja.loadRows();
        },
        searchRecaudadores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.recaudadores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open(
                "GET",
                url + "/search/usuarios?bodega_id=" + this.form.bodega_id + "&tipo=R&search=" + search,
                true
            );
            xmlhttp.send();
        },
        inputRecaudadores: function () {
            this.form.recaudadores_id.splice(0, this.form.recaudadores_id.length);
            for (let i = 0; i < this.selectedRecaudadores.length; i++) {
                this.form.recaudadores_id.push(this.selectedRecaudadores[i].id);
            }
        },
        inputBodega: function () {
            if (this.selectedBodega != null)
                this.form.bodega_id = this.selectedBodega.id;
            else  
                this.form.bodega_id = '';
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/ReporteEstadoCuenta.vue